module.exports = "/_next/static/fonts/NewSpiritCondensed-Regular-7c02304e57d5edf94b8ac256cb058332.woff2";